import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import DayJS from './helpers/DayJS'
import es from 'dayjs/locale/es'
import en from 'dayjs/locale/en'
import { isProduction } from './interfaces/constants'

// Add supported languages constant
const SUPPORTED_LANGUAGES = ['en', 'es', 'pt', 'gl']
const DEFAULT_LANGUAGE = 'es'

export type AvailableLanguages = Record<
    string,
    {
        name: string
        nativeName: string
        isReferenceLanguage: boolean
        translated: {
            latest: number
        }
    }
>

// Static language metadata (previously fetched from Locize)
export const AVAILABLE_LANGUAGES: AvailableLanguages = {
    en: { name: 'English', nativeName: 'English', isReferenceLanguage: false, translated: { latest: 100 } },
    es: { name: 'Spanish', nativeName: 'Español', isReferenceLanguage: true, translated: { latest: 100 } },
    pt: { name: 'Portuguese', nativeName: 'Português', isReferenceLanguage: false, translated: { latest: 100 } },
    gl: { name: 'Galician', nativeName: 'Galego', isReferenceLanguage: false, translated: { latest: 100 } },
}

i18n.use(initReactI18next)
    .use(HttpBackend)
    .use(LanguageDetector)
    .init(
        {
            debug: false,
            ns: [],
            load: 'languageOnly',
            fallbackLng: DEFAULT_LANGUAGE,
            supportedLngs: SUPPORTED_LANGUAGES,
            backend: {
                loadPath: isProduction
                    ? `${process.env.REACT_APP_TRANSLATIONS_URL}/{{lng}}/{{ns}}.json`
                    : '/locales/{{lng}}/{{ns}}.json',
            },
            interpolation: { escapeValue: false },
            react: {
                useSuspense: true,
            },
            cache: ['localStorage'],
            detection: {
                order: [
                    'querystring',
                    'cookie',
                    'localStorage',
                    'sessionStorage',
                    'navigator',
                    'htmlTag',
                    'path',
                    'subdomain',
                ],
                caches: ['localStorage', 'cookie'],
                cookieOptions: { path: '/', sameSite: 'strict' },
            },
        },
        err => {
            if (err) return console.log('something went wrong loading', err)
        }
    )

i18n.on('missingKey', (languages, namespace, key, res) => !isProduction && console.error({ languages, namespace, key, res }))

i18n.on('languageChanged', lng => {
    !isProduction && console.info(`Language changed to ${lng}`)
    const userLanguage = lng.split('-').at(0)
    userLanguage === 'es' ? DayJS.locale(es) : DayJS.locale(en)
})

export default i18n

export const plural = {
    count: 10,
}
